import TooltipInfo from "components/TooltipInfo";
import { BUILDER_CONFIG, CONFIG_CUSTOMIZATION, CUSTOMIZATION_THEME_SETTINGS, PAGE_LAYOUT, PAGE_LAYOUTS, THEME_SUBTITLES } from "constants/constants";
import { useAppContext } from "contexts/AppContext";
import _ from "lodash";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { Tooltip } from "react-tooltip";
import Utils from "Services/Utils";
import { TInfoText } from "types";

type MyProps = {
    title: string,
    required?: boolean
    description?: string,
    titleClassName?: string
    info?: TInfoText
    showLabel?: boolean
    id?: string
}

const Title = ({
    title, 
    required, 
    description,
    titleClassName,
    info,
    showLabel,
    id
}: MyProps) => {
    const {
        theme,
        activePage,
        builderSpec
    } = useAppContext()
    
    if (Utils.isConfigurator(theme) && showLabel === false) return <></>

    const styles: any = {}

    if(builderSpec?.[BUILDER_CONFIG]?.[CONFIG_CUSTOMIZATION]?.[CUSTOMIZATION_THEME_SETTINGS]?.[THEME_SUBTITLES])
        styles.color = builderSpec?.[BUILDER_CONFIG]?.[CONFIG_CUSTOMIZATION]?.[CUSTOMIZATION_THEME_SETTINGS]?.[THEME_SUBTITLES]

    return (
        <div className="">
            <p className={`sb3-font-normal sb3-text-black sb3-text-base sb3-space-x-1 ${titleClassName}`} style={styles}>
            <span className="sb3-font-normal sb3-text-black sb3-text-base" style={styles}>{title}</span>
            {required && <span className="sb3-text-red-500 !sb3-text-lg sb3-inline">*</span>}
            {info && <span className="sb3-inline-flex sb3-align-middle"><TooltipInfo data={info} id={(id ?? _.uniqueId())} title={title}/></span>}</p>

            <p className="sb3-text-gray-extraDark sb3-text-xs">{description}</p>
        </div>
    )
};

export default Title